module.exports = __webpack_public_path__ + "web/img/s2.4e0766ea.png";